<template>
  <div class="card">
    <card-m
      title="BOM相关进度"
      cardWidth="100%"
      cardHeight="100%"
      :show-export="true"
      export-file-name="设计BOM进度"
      @export="handleExport"
    >
      <template slot="card-box">
        <CardInfoTable
          ref="bomTable"
          :data="infoItems"
          :export-file-name="'设计BOM进度'"
          :items-per-row="tableColumns"
          :label-width="isMobile ? '10%' : '30%'"
          :row-height="isMobile ? '26px' : '28px'"
          :font-size="isMobile ? '12px' : '14px'"
          :label-bg-color="'rgba(37, 100, 207, 0.08)'"
          :border-color="'#dcdfe6'"
          :hover-effect="!isMobile"
          :empty-text="''"
        />
      </template>
    </card-m>
  </div>
</template>

<script>
export default {
  name: 'card-M',
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    tableColumns() {
      return this.isMobile ? 2 : 1;
    },
    rowData() {
      return this.tableData && this.tableData.length > 0 ? this.tableData[0] : {};
    },
    infoItems() {
      const d = this.rowData;
      return [
        { label: '父项型号', value: d.model || '' },
        { label: '设计人', value: d.member || '' },
        { label: '设计进度', value: d.progress != null ? Math.round(d.progress * 100) + '%' : '0%' },
        { label: '数量', value: d.qty || '' },
        { label: '难度', value: d.难度 || '' },
        // 新增三个超期天数，追加在表格最下面
        { label: '首次BOM超期天数', value: this.toText(d.首次BOM超期天数) },
        { label: '外购BOM超期天数', value: this.toText(d.外购BOM超期天数) },
        { label: '完整BOM超期天数', value: this.toText(d.完整BOM超期天数) }
      ];
    }
  },
  methods: {
    /** 超期天数文本化：空值/未返回 → ''；0 也照常显示为 "0" */
    toText(val) {
      if (val === '' || val == null) return '';
      return String(val);
    },
    handleExport() {
      if (this.$refs.bomTable && this.$refs.bomTable.handleExport) {
        this.$refs.bomTable.handleExport();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  width: 100%;
  height: 100%;
  max-height: 1000px;
}
</style>
